import { FilterValues } from '../MonitoringReport/MonitoringReport'
import { RangeValue } from 'types/shared'
import dayjs from 'dayjs'
import { incidentReportsConstants } from 'locale/incidentReports'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import SelectedFiltersDisplay from './SelectedFiltersDisplay'

type ContentType = RangeValue<dayjs.Dayjs> | string[]

export interface Filter {
  [key: string]: ContentType
}

interface SelectedFiltersProps {
  selectedFilters: Filter
}

type FilterKeys = keyof FilterValues
type FilterKeyTitle = Record<FilterKeys, string>

export const SelectedFilters = ({ selectedFilters }: SelectedFiltersProps) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)
  const filterKeyTitle: Partial<FilterKeyTitle> = {
    rangePicker: t(incidentReportsConstants.FILTER_DATE),
    residents: t(incidentReportsConstants.FILTER_RESIDENTS),
	  ownedBy: t(incidentReportsConstants.FILTER_OWNERS),
    homes: t(incidentReportsConstants.FILTER_SITES),
    categoryItems: t(incidentReportsConstants.FILTER_INCIDENT),
    locations: t(incidentReportsConstants.FILTER_LOCATION),
    statuses: t(incidentReportsConstants.FILTER_STATUS),
    severities: t(incidentReportsConstants.FILTER_SEVERITY),
    resultedIn: t(incidentReportsConstants.FILTER_RESULT),
  }

  return (
    <SelectedFiltersDisplay
      filterKeyTitle={filterKeyTitle}
      selectedFilters={selectedFilters}
    />
  )
}
